import { setupCalendar, Calendar, DatePicker } from 'v-calendar'
import vueSelect from 'vue-select'
import 'v-calendar/style.css'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.component('VSelect', vueSelect)

    nuxtApp.vueApp.use(setupCalendar, {})

    nuxtApp.vueApp.component('VCalendar', Calendar)
    nuxtApp.vueApp.component('VDatePicker', DatePicker)
})
